import i18n from './locales/index'

// 导入 process polyfill - 使用正确的路径
import process from 'process'
if (typeof window !== 'undefined') {
  window.process = process
}

require("@/utils/get_url_params")
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
require("@/utils/rem")
import ElementUI from 'element-ui'
import 'element-theme-dark';
require("./globalComponents")
require("./filters")
import { ErrorLogger } from './utils/errorLogger'
//require("./utils/v4_router")
//require("./utils/smart_router")
Vue.config.productionTip = false
window.mainNet = true;// 是否主链
Vue.use(ElementUI)

// 添加全局错误处理
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err);
  console.error('Error Info:', info);
  console.error('Component:', vm);
  
  // 将错误保存到localStorage以便后续查看
  const errorLog = {
    timestamp: new Date().toISOString(),
    error: err.message,
    stack: err.stack,
    info: info,
    component: vm ? vm.$options.name || 'unknown' : 'unknown'
  };
  
  const existingErrors = JSON.parse(localStorage.getItem('vueErrors') || '[]');
  existingErrors.push(errorLog);
  localStorage.setItem('vueErrors', JSON.stringify(existingErrors));
};

// 添加全局JavaScript错误监听
window.addEventListener('error', function(event) {
  console.error('Global Error:', event.error);
  console.error('Error Message:', event.message);
  console.error('Error Source:', event.filename);
  console.error('Error Line:', event.lineno);
  console.error('Error Column:', event.colno);
  
  // 保存错误信息
  const errorLog = {
    timestamp: new Date().toISOString(),
    type: 'global',
    message: event.message,
    source: event.filename,
    line: event.lineno,
    column: event.colno,
    stack: event.error ? event.error.stack : null
  };
  
  const existingErrors = JSON.parse(localStorage.getItem('jsErrors') || '[]');
  existingErrors.push(errorLog);
  localStorage.setItem('jsErrors', JSON.stringify(existingErrors));
});

// 添加未处理的Promise错误监听
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled Promise Rejection:', event.reason);
  
  const errorLog = {
    timestamp: new Date().toISOString(),
    type: 'promise',
    reason: event.reason
  };
  
  const existingErrors = JSON.parse(localStorage.getItem('promiseErrors') || '[]');
  existingErrors.push(errorLog);
  localStorage.setItem('promiseErrors', JSON.stringify(existingErrors));
});

setTimeout(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}, 300);
